// crypto-helpers.js
import * as CryptoJS from "crypto-js";
import { EncKeys } from "./config";

const encKey = CryptoJS.enc.Utf8.parse(EncKeys.VayanaEncKey);
const iv = CryptoJS.enc.Utf8.parse(EncKeys.IV);

export function encryptStringBase64(plainText) {
  const encrypted = CryptoJS.AES.encrypt(
    CryptoJS.enc.Utf8.parse(plainText),
    encKey,
    { 
      keySize: 128 / 8, 
      iv, 
      mode: CryptoJS.mode.CBC, 
      padding: CryptoJS.pad.Pkcs7 
    }
  );
  return encrypted.toString();
}

export function decryptStringBase64(base64Cipher) {
  if (!base64Cipher) return "";
  
  try {
    // Parse Base64 string into CipherParams format
    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: CryptoJS.enc.Base64.parse(base64Cipher) },
      encKey,
      { 
        iv, 
        mode: CryptoJS.mode.CBC, 
        padding: CryptoJS.pad.Pkcs7 
      }
    );
    
    const plaintext = CryptoJS.enc.Utf8.stringify(decrypted);
    
    if (!plaintext) {
      console.error("⚠️ Decryption failed - empty result. Check key/IV/ciphertext.");
    }
    
    return plaintext;
  } catch (error) {
    console.error("Decryption error:", error.message);
    return "";
  }
}

export function normalizeToJwtString(maybeWrapped) {
  if (!maybeWrapped) return "";
  const trimmed = maybeWrapped.trim();
  
  // Check if it's wrapped in JSON
  if (trimmed.startsWith("{")) {
    try {
      const obj = JSON.parse(trimmed);
      if (obj && typeof obj.token === "string") return obj.token;
    } catch (e) {
      console.error("Failed to parse JSON-wrapped token:", e);
    }
  }
  
  return trimmed;
}
